import { TipoEmpleadoEnumChoice, newCargosSchema } from "@/shared";
import { usefetchEmpresas } from "@/shared/actions/erp";
import {
  useCreateCargos,
  useUpdateCargos,
} from "@/shared/actions/erp/empleados";
import {
  CustomAutocomplete,
  CustomTextField,
  SampleCheckbox,
  SingleFormBoxScene,
} from "@/shared/components/ui";
import { Empresa } from "@/shared/interfaces";
import { Cargos } from "@/shared/interfaces/erp/empleados";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const returnUrlCargos = "/nomina/cargos";

export interface SaveCargoInterface {
  titlePage: string;
  editCargo?: Cargos;
}
type SaveFormData = {
  codigo: string;
  nombre: string;
  numero_referencia?: string;
  tipo_empleado: string;
  estado: boolean;
  empresa: string;
};
const SaveCargosPage: React.FC<SaveCargoInterface> = ({
  titlePage,
  editCargo,
}) => {
  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);
  ///* global state
  ///* mutations
  const createCargoMutation = useCreateCargos({
    navigate,
    returnUrl: returnUrlCargos,
  });
  const updateCargoMutation = useUpdateCargos({
    navigate,
    returnUrl: returnUrlCargos,
  });
  ///* fetch data
  const tipoEmpleadosOptions = Object.entries(TipoEmpleadoEnumChoice).map(
    ([key, value]) => ({ label: key, value }),
  );
  const { data: empresaPaging, isLoading: isLoadingEmpresa } = usefetchEmpresas(
    {
      page_size: 600,
    },
  );

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newCargosSchema),
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editCargo?.id_cargo) {
      return updateCargoMutation.mutate({
        id: editCargo.id_cargo,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createCargoMutation.mutate(form.getValues() as any);
  };

  ///* effects
  useEffect(() => {
    if (editCargo) {
      setShrink(true);
      reset({
        ...editCargo,
      } as any);
    }
  }, [editCargo]);

  const onChangeEmpresa = (value: string) => {
    form.setValue("empresa", value);
  };
  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlCargos);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Codigo"
        name="Codigo"
        control={control}
        error={errors.codigo}
        helperText={errors.codigo?.message}
        shrink={shrink}
      />
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={control}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />

      <CustomAutocomplete
        label="tipo empleado"
        name="tipo_empleado"
        control={form.control}
        defaultValue={form.getValues().tipo_empleado || ""}
        error={errors.tipo_empleado}
        helperText={errors.tipo_empleado?.message}
        options={tipoEmpleadosOptions}
        isLoadingData={false}
        valueKey="value"
        optionLabelForEdit={form.getValues().tipo_empleado}
      />
      <CustomAutocomplete<Empresa>
        label="Empresa"
        name="empresa"
        //// options
        options={empresaPaging?.data.data || []}
        // label & search by name
        valueKey="razon_social"
        actualValueKey="codigo"
        //
        defaultValue={form.getValues().empresa || ""}
        optionLabelForEdit={form.getValues().empresa || ""}
        isLoadingData={isLoadingEmpresa}
        //// validation
        control={control}
        error={errors.empresa}
        helperText={errors.empresa?.message}
        onChangeValue={onChangeEmpresa}
      />
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveCargosPage;
